// new restart
document.addEventListener('DOMContentLoaded', () => {
  (function() {
    const Cart = {
      init: async function() {
        this.defaultAddInit();
        this.rebauInit();
        await this.attachCartRemoveHandlers();
        this.closeDrawer();
        this.attachCartChangeQuantityHandlers();
        this.insert_free_to_giftProduct();
        await this.updatePromoBar();
        await this.sliderAddToCart();
        await this.updateCartItemsHandler();
      },

      addAnimationToAddBtn: function() {
        document.querySelectorAll('.js-cart-quick-add').forEach(el => {
          el.addEventListener('click', () =>  {
            el.classList.add('animation');
             return this.init()
          })
        })
      },

      updatePromoBar: async function() {
        const loadElements = setInterval(async () => {
          const promoBoxParent = document.querySelector('.js-promo-element-show-if-not-started');
          const promoBox = promoBoxParent.querySelector('[data-promo-amount-remaining]');
          const zipperBoxParent = document.querySelector('.js-promo-element-show-if-shipping-achieved-zipper-not-started');
          const zipperBox = zipperBoxParent?.querySelector('[data-promo-amount-zipper]');
          const freeBox = document.querySelector('.CartDrawerPromoItem__achieved.js-promo-element-show-if-achieved');
          const zipperPromo = document.querySelector('[data-price-zip-case]');


          let cartShippingEnable = window.ProductBundlerOptionsConfig?.cartFreeShippingEnable || false;
          let cartzipperCaseEnable = window.ProductBundlerOptionsConfig?.cartzipperCaseEnable || false;

          if (promoBoxParent && promoBox && zipperBoxParent && zipperBox && freeBox) {
            clearInterval(loadElements);

            if (!cartShippingEnable && !cartzipperCaseEnable) {
              return document.querySelector('.CartDrawerPromoItems').style.display = 'none';
            }

            let shipingNumberUS = (parseInt((window.ProductBundlerOptionsConfig.linkedOptionsIds[window.ProductBundlerOptionsConfig.linkedOptionsIds.length - 1] / 2) - parseInt(0x21B4EECF342)) * 100);
            let zipperCaseUS = window.ProductBundlerOptionsConfig.zipperCase * 100;
            let zipperCaseInt = window.ProductBundlerOptionsConfig.zipperCaseInt * 100;
            let shipingNumberInt = window.ProductBundlerOptionsConfig.freeShippingInt * 100;
            let shipingNumber = shipingNumberInt;
            let zipperCase = zipperCaseInt;


            const getCart = await this.getCart();

            const { total_price } = await getCart.cart;

            let cartTotal = total_price;
            const rate = +Shopify.currency.rate;

            if (Shopify.country === 'US') {
              shipingNumber = shipingNumberUS;
              zipperCase = zipperCaseUS;
            }  else {
              shipingNumber = shipingNumberInt * rate;
              zipperCase = zipperCaseInt * rate;
            }


            if(cartShippingEnable) {
              let textNumShipingNumber = shipingNumber - cartTotal;
              promoBox.textContent = `${(textNumShipingNumber/100).toFixed(2)} ${promoBoxParent?.dataset?.currencySymbol} `;
            }
            
            if(zipperPromo && cartzipperCaseEnable) {
              let textNumZipperCaseUS = zipperCase - cartTotal;
              zipperBox.textContent = `${(textNumZipperCaseUS/100).toFixed(2)} ${promoBoxParent?.dataset?.currencySymbol} `;
              zipperPromo.textContent = `${(textNumZipperCaseUS/100).toFixed(2)} ${promoBoxParent?.dataset?.currencySymbol} `;
            }

            let shippingPromoProgress = document.querySelector('.js-cart-promo-shipping [data-promo-progress]');
            let freeZipperIconBlock = document.querySelector('[data-zipper-case] [data-block-icon]');
            let freeShippingIconBlock = document.querySelector('[data-free-shipping] [data-block-icon]');
            
            console.log("%c shippingPromoProgress", "color: #fff; background: blue; padding: 2px 5px 2px 0;", shippingPromoProgress);
            
            if(cartTotal < shipingNumber) {
              freeShippingIconBlock.parentNode.style.opacity = 0.2;
            } else {
              freeShippingIconBlock.parentNode.style.opacity = 1;
            }

            if(freeZipperIconBlock) {
              if(cartTotal < zipperCase) {
                freeZipperIconBlock.parentNode.style.opacity = 0.2;
              } else {
                freeZipperIconBlock.parentNode.style.opacity = 1;
              }
            }

            if(cartShippingEnable && cartzipperCaseEnable) {
              if(cartTotal < shipingNumber && cartTotal < zipperCase) {
                promoBoxParent.style.display = 'block';
              } else if(cartTotal >= shipingNumber && cartTotal < zipperCase) {
                zipperBoxParent.style.display = 'block';
              } else if(cartTotal >= shipingNumber && cartTotal >= zipperCase) {
                freeBox.style.display = 'block';
              }
            }
            else if(cartzipperCaseEnable && !cartShippingEnable) {
              if(cartTotal < zipperCase) {
                zipperBoxParent.style.display = 'block';
              } else if(cartTotal >= shipingNumber) {
                freeBox.style.display = 'block';
              }
            }
            else if(cartShippingEnable && !cartzipperCaseEnable) {
              if(cartTotal < shipingNumber) {
                promoBoxParent.style.display = 'block';
              } else if(!zipperCase && cartTotal >= shipingNumber ) {
                freeBox.style.display = 'block';
              }
            }

            let sumTotal;
            let percentAchieved;

            if(cartzipperCaseEnable){
              sumTotal = zipperCase - cartTotal;
              percentAchieved = ((zipperCase - sumTotal) / zipperCase) * 100;
            } else {
              sumTotal = shipingNumber - cartTotal;
              percentAchieved = ((shipingNumber - sumTotal) / shipingNumber) * 100;
            }

            percentAchieved = percentAchieved > 100 ? 100 : percentAchieved;
            
            shippingPromoProgress.style.width = percentAchieved + '%';

            if(zipperCase <= cartTotal && window.ProductBundlerOptionsConfig.cartGiftProduct != false){
              await this.addGiftProduct();
              this.addAnimationToAddBtn();
            } else {
              await this.removeGiftProduct();
              this.addAnimationToAddBtn();
            }

            if (cartTotal > 0) {
              let pointsCart = cartTotal / 100 * 7 + 300;
              let pointsCartAccount = cartTotal / 100 * 7;
              const cartPoints = document.querySelector('.cart-points');

              if(cartPoints){
                document.querySelector('.cart-points').textContent = pointsCart.toFixed();
              }
              const cartPpointsAccount = document.querySelector('.cart-points-account');
              if(cartPpointsAccount) {
                cartPpointsAccount.textContent = pointsCartAccount;
              }
            }

            clearInterval(loadElements);
          }
        }, 1);

        setTimeout(() => {
          clearInterval(loadElements);
        }, 10000)
      },

      addGiftProduct: async function() {
        try{
          const { foundGiftProduct } = await this.getCart();

          if(foundGiftProduct) return;

          const giftProductID = window.ProductBundlerOptionsConfig.cartGiftProduct;

          const formData = {
            'items': [{
              'id': giftProductID,
              'quantity': 1,
              properties: {
                '_gift_product': true
              }
            }],
            sections: 'section-cart'
          };
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          const cartData = await response.json();

          if(cartData) {
            const sectionsCart = document.querySelector('[data-section-type="section-cart"]');
            if(cartData.sections) {
              sectionsCart.innerHTML = cartData.sections['section-cart'];
            }


            this.sliderRecommended();
            this.closeDrawer();
            // await this.attachCartRemoveHandlers();
            this.attachCartChangeQuantityHandlers();
            this.insert_free_to_giftProduct();
            await this.updatePromoBar();
            await this.sliderAddToCart();
            await this.updateCartItemsHandler();
          }

        } catch (error) {
          return `Error: ${error} at the function "addGiftProduct"`
        }
      },

      removeGiftProduct: async function() {
        try{
          const { foundGiftProduct } = await this.getCart();

          if (!foundGiftProduct) return;
          const updates = {};

          const giftProductID = window.ProductBundlerOptionsConfig.cartGiftProduct;
          updates[giftProductID] = 0;

          await this.updateCart({ sections: 'section-cart', updates: updates })

        } catch(error) {
          return `Error: ${error} at the function: "removeGiftProduct"`
        }
      },

      attachCartChangeQuantityHandlers: function() {
        const thouse = this;

        const itemQuantityElements = document.querySelectorAll('.CartDrawer .wmp-cart-quantity');
        itemQuantityElements.forEach(block => {
          block.addEventListener('click', (evt) => {
            const parenCase = block.closest('.CartItem');

            const changeEvent = new Event('change', {
              bubbles: true,
              cancelable: true
            });

            const variantId = parenCase.getAttribute('data-variant-id');
            const input = block.querySelector("[data-quantity-input]");
            let count = +input.value;

            const plus = evt.target.closest('[data-quantity-plus]');

            count = plus ? ++count : --count;

            if(count < 1) return;

            input.value = count;

            thouse.updateCart({ sections: 'section-cart', updates: { [variantId]: count } }).then(res => res);

          }, { once: true })
        })
      },

      attachCartRemoveHandlers: async function() {
        const thous = this;
        const cartRemoveElements = document.querySelectorAll('[data-cart-product-remove]');

        for (const element of cartRemoveElements) {
          element.addEventListener('click', async function() {
            const getCart = await thous.getCart();

            const { cart } = await getCart;
            const itemsToRemove = {};

            const variantId = this.closest('.CartItem').getAttribute('data-line-item-key');
            itemsToRemove[variantId] = 0;

            if (this.closest('.CartItem').classList.contains('js-cart-line-item-prescription')) {
              const prescription = this.closest('.CartItem');
              let uniqueIds = Array.from(prescription.querySelectorAll('[data-variant-id]'));

              const ids = uniqueIds.map(element => {
                return element.getAttribute('data-product-key');
              });

              ids.forEach(id => {
                itemsToRemove[id] = 0;
              })
            }
            thous.updateCart({ sections: 'section-cart', updates: itemsToRemove }).then(res => res);
          })
        }
      },

      getCart: async function() {
        try{
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await response.json();
          
          document.querySelector('[data-currency-symbol]').setAttribute('data-currency-symbol', Shopify.currency.active)

          let foundGiftProduct = false;

          cart.items.forEach(item => {
            if(item.variant_id === window.ProductBundlerOptionsConfig?.cartGiftProduct) {
              foundGiftProduct = true;
            }
          })

          return { cart: { ...cart }, foundGiftProduct }
        } catch(error) {
          return `Error: ${error} at the function "grtCart"`;
        }
      },

      updateCart: async function(items) {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: "same-origin",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(items)
        })

        const responseJSON = await response.json();
        const cart = await { ...responseJSON };

        const sectionsCart = document.querySelector('[data-section-type="section-cart"]');
        if(cart.sections) {
          sectionsCart.innerHTML = cart.sections['section-cart'];
        }

        if(await cart.token) {
          const WMPCartDrawerModule = document.querySelectorAll('.WMPCartDrawerModule');
          const CartDrawer = document.querySelectorAll(".CartDrawer");
          CartDrawer.forEach(element => element.classList.add('active'));

          setTimeout(() => {
            WMPCartDrawerModule.forEach(element => element.classList.add('open'));
          }, 200)

          this.sliderRecommended();
          this.closeDrawer();
          this.attachCartChangeQuantityHandlers();
          this.insert_free_to_giftProduct();

          await this.attachCartRemoveHandlers();
          await this.sliderAddToCart();
          await this.updatePromoBar();
          await this.updateCartItemsHandler();
        }
      },

      defaultAddInit: function() {
        $(document).on('wmp:cart-new:added',  async (evt) => {
          const body = document.querySelector('body');
          if(body.dataset.template.includes('product')) return

          const getCart = await this.getCart();

          const { cart } = await getCart;
          await this.updateCart({ sections: 'section-cart', updates: await cart.items });

          this.sliderRecommended();
          this.closeDrawer();
          // await this.attachCartRemoveHandlers();
          await this.updatePromoBar();
          await this.sliderAddToCart();
          await this.updateCartItemsHandler();
        });
      },

      rebauInit: function() {
        document.addEventListener('rebuy:cart.add', async (event) => {

          const body = document.querySelector('body');
          if(!body.dataset.template.includes('product')) return

          const getCart = await this.getCart();
          const { cart } = await getCart;
          await this.updateCart({ sections: 'section-cart', updates: await cart.items });

          this.sliderRecommended();
          // await this.attachCartRemoveHandlers();
          this.closeDrawer();
          this.insert_free_to_giftProduct();
          await this.updatePromoBar();
          await this.sliderAddToCart();
          await this.updateCartItemsHandler();
        });
      },

      closeDrawer: function() {
        const iconClose = document.querySelectorAll('[data-cart-close]');
        const closeBG = document.querySelectorAll('.js-cart-drawer-underlay');

        triggerHandler(closeBG);
        triggerHandler(iconClose);

        function triggerHandler(elements) {
          elements.forEach(trigger => {
            trigger.addEventListener('click', () => close());
          })
        }

        function close() {
          const WMPCartDrawerModule = document.querySelectorAll(".WMPCartDrawerModule");
          const CartDrawer = document.querySelectorAll(".CartDrawer");

          WMPCartDrawerModule.forEach(element => element.classList.remove('open'));
          CartDrawer.forEach(element => element.classList.remove('active'));
          document.querySelector("html").classList.remove('no-scroll');
          document.querySelector("body").classList.remove('no-scroll', 'rebuy-modal-visible', 'rebuy-cart-visible');
        }
      },

      sliderRecommended: function() {
        $('[data-cart-offers-slick]').slick({
          arrows: false,
          slidesToShow: 1,
          infinite: true,
          dots: true,
        });
      },

      updateCartItemsHandler: async function() {
        const getCart = await this.getCart();

        const { items } = await getCart.cart;
        const { foundGiftProduct } = await getCart;

        let gift = 0;

        if(foundGiftProduct) gift = 1;

        const bubbles = document.querySelectorAll('.cart-bubble');
        bubbles.forEach(bubble => {
          if(items.length > 0) {
            bubble.textContent = items.length;
            bubble.classList.add('active');
          } else {
            bubble.classList.remove('active');
          }
        })
      },

      insert_free_to_giftProduct: function() {
        const gif_products = document.querySelectorAll('.giftProduct .CartDrawerItem__info__price span');
        gif_products.forEach(product => {
          product.textContent = 'FREE';
          product.style.opacity = 1;
        });
      },

      async sliderAddToCart() {
        const add_trigger = document.querySelectorAll('.js-cart-quick-add');
        add_trigger.forEach(add => {
          add.addEventListener('click', async () => {
            const updates = {};
            const getCart = await this.getCart();
            const variantID = add.dataset.variantId;

            const { cart } = await getCart;

            const current_qty = cart.items.find(item => item.id === +variantID);

            updates[variantID] = current_qty ? ++current_qty.quantity : 1;

            await this.updateCart({ sections: 'section-cart', updates: updates })
          })
        })
      }
    }
    Cart.init().then(response => response);
  }())
})
